__turbopack_context__.v({
  "button": "Button-module__4hUmeq__button",
  "filled": "Button-module__4hUmeq__filled",
  "ghost": "Button-module__4hUmeq__ghost",
  "outline": "Button-module__4hUmeq__outline",
  "primary": "Button-module__4hUmeq__primary",
  "secondary": "Button-module__4hUmeq__secondary",
});
